AddSectionCommentMixin = require 'components/mixins/add_section_comment_mixin'
ChapterManagementMixin = require 'components/mixins/chapter_management_mixin'
ChapterSectionContent = require 'components/document_sections/v2/chapter_section_content'
ChapterSectionStatus = require 'components/document_sections/v2/chapter_section_status'
DiscardChangesActions = require 'actions/discard_changes_actions'
DocumentSectionsTitle = require 'components/document_sections/v2/document_sections_title'
DocumentSectionsV2Actions = require 'actions/document_sections_v2_actions'
DropdownMenu = require 'components/common/dropdown_menu'
EditingByInfo = require 'components/document_sections/v2/editing_by_info'
IconButton = require 'components/common/icon_button'
mediator = require 'mediator'
{
  getSettingsOptions,
  getSettingsOrder
} = require 'lib/document_sections_v2_helper'

TextSection = createReactClass
  displayName: 'TextSection'

  propTypes:
    acceptedOrRejectedChange: PropTypes.shape({
      sectionId: PropTypes.string.isRequired,
      changeId: PropTypes.string.isRequired
      accepted: PropTypes.bool.isRequired
    })
    chapterId: PropTypes.string.isRequired
    draftDiscussions: PropTypes.instanceOf(Immutable.Map)
    editingSection: PropTypes.instanceOf(Immutable.Map).isRequired
    hasChanges: PropTypes.bool.isRequired
    mdaTopicId: PropTypes.string
    onDelete: PropTypes.func.isRequired
    onInsertMdaTable: PropTypes.func.isRequired
    onInsertRecommendation: PropTypes.func.isRequired
    onInsertReferences: PropTypes.func.isRequired
    readOnly: PropTypes.bool.isRequired
    scrollToSectionContent: PropTypes.shape({
      sectionId: PropTypes.string.isRequired,
      contentPos: PropTypes.number.isRequired
    })
    section: PropTypes.instanceOf(Immutable.Map).isRequired
    suggesting: PropTypes.bool.isRequired
    withHeader: PropTypes.bool,
    updatedDraftDiscussion: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
      discussionType: PropTypes.string.isRequired
      data: PropTypes.object
    })


  getDefaultProps: ->
    withHeader: true

  mixins: [ChapterManagementMixin, AddSectionCommentMixin]

  componentDidUpdate: (prevProps) ->
    if prevProps.section.get('title') isnt @props.section.get('title') # title has been saved
      _.defer ->
        DiscardChangesActions.setHasChanges(false)

  updateField: (key, value) ->
    projectId = mediator.project.id
    chapterId = @props.section.get('parent')
    sectionId = @props.section.get('_id')
    DocumentSectionsV2Actions.setSectionProperty(
      projectId, chapterId, sectionId, key, value
    )

  handleTitleChange: _.debounce((changedTitle) -> # in case if someone writes very fast
    hasChanges = changedTitle isnt @props.section.get('title')
    DiscardChangesActions.setHasChanges(hasChanges)
  , 500)

  handleTitleSave: (changedTitle) ->
    @updateField('title', changedTitle)

  handleContentSave: (changedContent) ->
    { section, chapterId } = @props
    sectionId = section.get('_id')
    projectId = mediator.project.id
    DiscardChangesActions.setHasChanges(false)
    DocumentSectionsV2Actions.saveChapterContent {
      projectId,
      chapterId,
      sectionId,
      content: changedContent
      directSave: true
    }

  handleStatusSave: (changedStatus) ->
    @updateField('status', changedStatus)

  handleSettingSelect: (selectedSetting) ->
    { section, chapterId } = @props
    sectionId = section.get('_id')

    switch selectedSetting
      when 'add_new_text_field'
        DocumentSectionsV2Actions.addSection(mediator.project.id, chapterId, sectionId)
      when 'insert_subchapter'
        DocumentSectionsV2Actions.insertSubchapter(mediator.project.id, chapterId)
      when 'insert_mda_table'
        @props.onInsertMdaTable({ sectionId })
      when 'insert_recommendation'
        @props.onInsertRecommendation({ sectionId })
      when 'duplicate'
        @duplicateSection()
      when 'delete'
        sectionId = @props.section.get('_id')
        @props.onDelete(sectionId)
      when 'insert_references'
        @props.onInsertReferences({ chapterId, sectionId })

  duplicateSection: () ->
    projectId = mediator.project.id
    chapterId = @props.section.get('parent')
    sectionId = @props.section.get('_id')
    DocumentSectionsV2Actions.duplicateSection(projectId, chapterId, sectionId)

  updateDraftDiscussions: (type, data) ->
    { chapterId, section } = @props
    sectionId = section.get('_id')
    DocumentSectionsV2Actions.updateDraftDiscussions { chapterId, sectionId, type, data }

  _updateSectionEditingInfo: (editing) ->
    { chapterId, section } = @props
    sectionId = section.get('_id')
    projectId = mediator.project.id
    user = {
      id: mediator.user.id
      name: mediator.user.getFullName()
    }

    DocumentSectionsV2Actions.updateSectionEditingInfo {
      projectId,
      chapterId,
      sectionId,
      user,
      editing,
    }

  startedEditing: (content) ->
    sectionId = @props.section.get('_id')
    DocumentSectionsV2Actions.sectionEditStarted { sectionId, content }
    @_updateSectionEditingInfo(true)

  handleEditCancel: ->
    { section } = @props
    sectionId = section.get('_id')
    DocumentSectionsV2Actions.flushDraftDiscussions { sectionId }
    DiscardChangesActions.setHasChanges false
    @_updateSectionEditingInfo(false)

  handleAddSectionComment: ->
    if @props.readOnly and mediator.user.hasRole 'mda_mab'
      @handleAddComment('section_comment') # this comes from AddSectionCommentMixin

  render: ->
    {
      acceptedOrRejectedChange,
      connectDragSource,
      draftDiscussions,
      editingSection,
      hasChanges,
      mdaTopicId,
      onInsertReferences,
      readOnly,
      scrollToSectionContent,
      section,
      suggesting,
      updatedDraftDiscussion,
      withHeader
    } = @props

    editingBy = section.get 'editingBy'
    sectionId = section.get('_id')

    <React.Fragment>
      {if editingBy
        <EditingByInfo data={editingBy} />
      }
      {withHeader && <div className="chapter-section-header">
        {connectDragSource(
          <div className="drag-marker" />
        )}
        <DocumentSectionsTitle
          sectionId={section.get('_id')}
          title={section.get('title')}
          onChange={@handleTitleChange}
          onSave={@handleTitleSave}
          hasReferences={section.get('refIds', Immutable.List()).size > 0}}
          onInsertReferences={onInsertReferences}
        />
        {@showChapterManagement() and <div className="chapter-section-management">
          <ChapterSectionStatus
            status={section.get('status')}
            onChange={@handleStatusSave}
          />
          <DropdownMenu
            opener={(
              <IconButton iconName="more" className="settings-toggle" />
            )}
            options={getSettingsOptions getSettingsOrder('text-section')}
            onSelect={@handleSettingSelect}
          />
        </div>}
      </div>}

      <ChapterSectionContent
        acceptedOrRejectedChange={acceptedOrRejectedChange}
        handleAddSectionComment={@handleAddSectionComment()}
        content={section.get('content')}
        draftDiscussions={draftDiscussions}
        editingSection={editingSection}
        hasChanges={hasChanges}
        mdaTopicId={mdaTopicId}
        onCancel={@handleEditCancel}
        onEditingStarted={@startedEditing}
        onSave={@handleContentSave}
        readOnly={readOnly}
        section={section}
        scrollToSectionContent={scrollToSectionContent}
        sectionId={sectionId}
        suggesting={suggesting}
        updatedDraftDiscussion={updatedDraftDiscussion}
        updateDraftDiscussions={@updateDraftDiscussions}
      />

    </React.Fragment>

module.exports = TextSection
